import fetchApi from './requests';
import { GetFactureUrl } from '../Routes/facture.route';
import { FactureDataType } from '../Types/facture.type';

export const getFactureData = async (
  factureId: string
): Promise<FactureDataType> => {
  const response = await fetchApi(GetFactureUrl(), { factureId });

  return response.ok ? response.data : null;
};
